// Modal.js
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
// import './Modal.css';

const createPortalDiv = () => {
    const portalDiv = document.createElement('div');
    portalDiv.id = 'portal';
    document.body.appendChild(portalDiv);
    return portalDiv;
};

const getPortalDiv = () => {
    return document.getElementById('portal') || createPortalDiv();
};

const Modalcustom = ({ open, onClose, style, children,container }) => {
    if (!open) return null;

    const handleClickOutside = (e) => {
        if (e.target.classList.contains('modal-overlay')) {
            onClose();
        }
    };

    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : 'unset';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [open]);

    return ReactDOM.createPortal(
        <div className={`modal-overlay ${style}`} onClick={handleClickOutside}>
            <div className={`modal-container ${container}`}>
                {/* <button className="modal-close-button" onClick={onClose}>X</button> */}
                <div className="modal-content">{children}</div>
            </div>
        </div>,
        getPortalDiv()
    );
};

export default Modalcustom;
